module.exports = __webpack_public_path__ + "static/media/speaker.7198542c.png";